export const itemTags = {
  beverage: { key: "beverage", display: "Beverage" },
  draught: { key: "draught", display: "Draught" },
  cask: { key: "cask", display: "Cask" },
  keg: { key: "keg", display: "Keg" },
  glassware: { key: "glassware", display: "Glassware" },
  snack: { key: "snack", display: "Snack" },
  bottle: { key: "bottle", display: "Bottle" },
  can: { key: "can", display: "Can" },
  bagInBox: { key: "bagInBox", display: "Bag In Box" },
} satisfies Record<
  string,
  {
    key: string;
    display: string;
  }
>;

export type ItemTag = keyof typeof itemTags;

export const orderableItemsObject = {
  bottle: {
    key: "bottle",
    display: "Bottle",
    itemTags: ["beverage", "bottle"],
    materialType: null,
  },
  can: {
    key: "can",
    display: "Can",
    itemTags: ["beverage", "can"],
    materialType: null,
  },
  keyCask: {
    key: "keyCask",
    display: "KeyCask",
    itemTags: ["beverage", "draught", "cask"],
    materialType: null,
  },
  eCask: {
    key: "eCask",
    display: "eCask",
    itemTags: ["beverage", "draught", "cask"],
    materialType: null,
  },
  cask: {
    key: "cask",
    display: "Cask",
    itemTags: ["beverage", "draught", "cask"],
    materialType: null,
  },
  miniCask: {
    key: "miniCask",
    display: "Mini Cask",
    itemTags: ["beverage", "draught", "cask"],
    materialType: null,
  },
  polyPin: {
    key: "polyPin",
    display: "PolyPin",
    itemTags: ["beverage", "draught", "cask"],
    materialType: null,
  },
  flatBottomPin: {
    key: "flatBottomPin",
    display: "Flat Bottom Pin",
    itemTags: ["beverage", "draught", "cask"],
    materialType: null,
  },
  caskKegstar: {
    key: "caskKegstar",
    display: "Cask - Kegstar",
    itemTags: ["beverage", "draught", "cask"],
    materialType: null,
  },
  caskBranded: {
    key: "caskBranded",
    display: "Cask - Branded",
    itemTags: ["beverage", "draught", "cask"],
    materialType: null,
  },
  sankeyKeg: {
    key: "sankeyKeg",
    display: "Sankey Keg",
    itemTags: ["beverage", "draught", "keg"],
    materialType: "steelKeg",
  },
  keyKeg: {
    key: "keyKeg",
    display: "KeyKeg",
    itemTags: ["beverage", "draught", "keg"],
    materialType: "plasticKeg",
  },
  eKeg: {
    key: "eKeg",
    display: "E-Keg",
    itemTags: ["beverage", "draught", "keg"],
    materialType: "steelKeg",
  },
  americanKeg: {
    key: "americanKeg",
    display: "A-type Keg",
    itemTags: ["beverage", "keg"],
    materialType: "steelKeg",
  },
  polyKeg: {
    key: "polyKeg",
    display: "PolyKeg",
    itemTags: ["beverage", "draught", "keg"],
    materialType: "plasticKeg",
  },
  grundyKeg: {
    key: "grundyKeg",
    display: "G-Type Grundy Keg",
    itemTags: ["beverage", "draught", "keg"],
    materialType: "steelKeg",
  },
  ecoKeg: {
    key: "ecoKeg",
    display: "EcoKeg",
    itemTags: ["beverage", "draught", "keg"],
    materialType: "plasticKeg",
  },
  miniKeg: {
    key: "miniKeg",
    display: "MiniKeg",
    itemTags: ["beverage", "draught", "keg"],
    materialType: "steelKeg",
  },
  sTypeKonvoyKeg: {
    key: "sTypeKonvoyKeg",
    display: "S-Type Konvoy Keg",
    itemTags: ["beverage", "draught", "keg"],
    materialType: "steelKeg",
  },
  nitroSankeyKeg: {
    key: "nitroSankeyKeg",
    display: "Nitro Sankey Keg",
    itemTags: ["beverage", "draught", "keg"],
    materialType: "steelKeg",
  },
  nitroKeyKeg: {
    key: "nitroKeyKeg",
    display: "Nitro Keykeg",
    itemTags: ["beverage", "draught", "keg"],
    materialType: "plasticKeg",
  },
  sTypeKegstar: {
    key: "sTypeKegstar",
    display: "S-Type Kegstar",
    itemTags: ["beverage", "draught", "keg"],
    materialType: "steelKeg",
  },
  dTypeKeg: {
    key: "dTypeKeg",
    display: "D-Type Keg",
    itemTags: ["beverage", "draught", "keg"],
    materialType: "steelKeg",
  },
  mTypeKeg: {
    key: "mTypeKeg",
    display: "M-Type Keg",
    itemTags: ["beverage", "draught", "keg"],
    materialType: "steelKeg",
  },
  corneliusKeg: {
    key: "corneliusKeg",
    display: "Cornelius Keg",
    itemTags: ["beverage", "draught", "keg"],
    materialType: "steelKeg",
  },
  polyKegBagged: {
    key: "polyKegBagged",
    display: "Polykeg - Bagged",
    itemTags: ["beverage", "draught", "keg"],
    materialType: "plasticKeg",
  },
  sTypeUniKeg: {
    key: "sTypeUniKeg",
    display: "S-Type UniKeg",
    itemTags: ["beverage", "draught", "keg"],
    materialType: "plasticKeg",
  },
  sTypeTalosKeg: {
    key: "sTypeTalosKeg",
    display: "S-Type Talos Keg",
    itemTags: ["beverage", "draught", "keg"],
    materialType: "plasticKeg",
  },
  dTypeUniKeg: {
    key: "dTypeUniKeg",
    display: "D-Type UniKeg",
    itemTags: ["beverage", "draught", "keg"],
    materialType: "plasticKeg",
  },
  polyKegBaggedKeyKegCoupler: {
    key: "polyKegBaggedKeyKegCoupler",
    display: "Polykeg - Bagged - KeyKeg Coupler",
    itemTags: ["beverage", "draught", "keg"],
    materialType: "plasticKeg",
  },
  polyKegBaggedSankeyCoupler: {
    key: "polyKegBaggedSankeyCoupler",
    display: "Polykeg - Bagged - Sankey Coupler",
    itemTags: ["beverage", "draught", "keg"],
    materialType: "plasticKeg",
  },
  polyKegBagless: {
    key: "polyKegBagless",
    display: "Polykeg - Bagless",
    itemTags: ["beverage", "draught", "keg"],
    materialType: "plasticKeg",
  },
  petainerKeg: {
    key: "petainerKeg",
    display: "Petainer Keg",
    itemTags: ["beverage", "draught", "keg"],
    materialType: "plasticKeg",
  },
  doliumKeg: {
    key: "doliumKeg",
    display: "Dolium Keg",
    itemTags: ["beverage", "draught", "keg"],
    materialType: "plasticKeg",
  },
  pouch: {
    key: "pouch",
    display: "Pouch",
    itemTags: ["beverage"],
    materialType: null,
  },
  bagInBox: {
    key: "bagInBox",
    display: "Bag In Box",
    itemTags: ["beverage"],
    materialType: null,
  },
  jerryCan: {
    key: "jerryCan",
    display: "Jerry Can",
    itemTags: ["beverage"],
    materialType: null,
  },
  box: {
    key: "box",
    display: "Box",
    itemTags: ["beverage"],
    materialType: null,
  },
  glass: {
    display: "Glass",
    key: "glass",
    itemTags: ["glassware"],
    materialType: null,
  },
  tuboGlass: {
    display: "Tubo Glass",
    key: "tuboGlass",
    itemTags: ["glassware"],
    materialType: null,
  },
  bag: {
    display: "Bag",
    key: "bag",
    itemTags: ["snack"],
    materialType: null,
  },
  jar: {
    display: "Jar",
    key: "jar",
    itemTags: ["snack"],
    materialType: null,
  },
  misc: {
    display: "Miscellaneous",
    key: "misc",
    itemTags: [],
    materialType: null,
  },
} as const satisfies Record<
  string,
  {
    key: string;
    display: string;
    itemTags: (keyof typeof itemTags)[];
    //do we need materialType for all orderableItems? The start of category specific properties?
    materialType: string | null;
  }
>;

export const orderableItemValues = Object.values(orderableItemsObject);

export type OrderableItemKey = keyof typeof orderableItemsObject;
